import { render, staticRenderFns } from "./CorrectGuide.vue?vue&type=template&id=3029a45f&scoped=true&lang=pug&"
import script from "./CorrectGuide.vue?vue&type=script&lang=ts&"
export * from "./CorrectGuide.vue?vue&type=script&lang=ts&"
import style0 from "./CorrectGuide.vue?vue&type=style&index=0&id=3029a45f&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3029a45f",
  null
  
)

export default component.exports